exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".classConfirmationContainer---2UCAF {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  outline: none; }\n\n.icon---c3K6w {\n  width: 80px;\n  height: 75px; }\n\n.title---1YUhn {\n  width: 90%;\n  min-height: 22px;\n  margin: 33px;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 1.2em;\n  text-align: center; }\n\n.title---1YUhn span {\n    color: #1981c4; }\n\n.buttonWrapper---20VHU {\n  min-width: 120px; }\n\n@media screen and (max-width: 1000px) {\n  .buttonWrapper---20VHU {\n    min-width: 30%; } }\n", ""]);

// exports
exports.locals = {
	"classConfirmationContainer": "classConfirmationContainer---2UCAF",
	"icon": "icon---c3K6w",
	"title": "title---1YUhn",
	"buttonWrapper": "buttonWrapper---20VHU"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/class-confirmation/index.scss
// module id = 1139
// module chunks = 3